import { ref } from 'vue'
import sk from '@/translations/sk'
import en from '@/translations/en'
import uk from '@/translations/uk' // ukrainian

const ALLOWED_LANGUAGES = ['sk', 'en', 'uk']
const DEFAULT_LANGUAGE = 'sk'

const language = ref(DEFAULT_LANGUAGE)

interface SourceTranslation {
  [key: string]: {
    [key: string]: string
  }
}

const all: SourceTranslation = {
  sk,
  en,
  uk,
}

export function useLanguage() {
  const setLanguage = (lang: string | null) => {
    if (lang === null) return
    if (ALLOWED_LANGUAGES.includes(lang)) language.value = lang
  }

  const detectLanguage = () => {
    setLanguage(document.documentElement.getAttribute('lang'))
  }

  return {
    language,
    detectLanguage,
  }
}

export function useTranslateSource() {
  const ts = (lang: string, value: string) => {
    if (!all[lang] || !all[lang][value]) return ''
    return all[lang][value]
  }

  return {
    ts,
  }
}
